module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon8.3bde2541.png";